import { plural } from '@cian/utils';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { formatRate } from '../getResponseTimeText';

export const getCountSubtitle = (reviewsCount: number) => {
  return `${reviewsCount} ${plural(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`;
};

export const getRatingSubtitle = ({
  reviewsCount,
  reviewsRate,
}: Pick<ISpecialistCatalogListingSchema, 'reviewsCount' | 'reviewsRate'>) =>
  reviewsCount && reviewsCount > 0 && reviewsRate
    ? `${formatRate(reviewsRate)}・${getCountSubtitle(reviewsCount)}`
    : 'Нет оценок и отзывов';
